"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
require("./Select.css");
var icons_1 = require("@tiendanube/icons");
var renders_1 = require("./renders");
function Select(_a) {
    var name = _a.name, selectLabel = _a.label, Icon = _a.labelIcon, options = _a.options, _b = _a.value, selectValue = _b === void 0 ? "" : _b, placeholder = _a.placeholder, onChange = _a.onChange;
    var handleChange = React.useCallback(function (event) {
        var target = event.target;
        onChange({ name: target.name, value: target.value });
    }, [onChange]);
    var memorizedLabel = React.useMemo(function () {
        return selectLabel && (React.createElement("label", { className: "nimbus--select__label", htmlFor: "select_" + name },
            Icon && (React.createElement("div", { className: "nimbus--select__label-icon" },
                React.createElement(Icon, null))),
            selectLabel));
    }, [selectLabel, name, Icon]);
    var memorizedPlaceholder = React.useMemo(function () {
        return (placeholder && (React.createElement("option", { value: "", disabled: true }, placeholder)));
    }, [placeholder]);
    var memorizedOptions = React.useMemo(function () {
        return options.map(function (opt) {
            var group = opt;
            var option = opt;
            if (group.group) {
                return (React.createElement(renders_1.RenderGroup, { key: "grp_" + group.group, group: group.group, options: group.options }));
            }
            return (React.createElement(renders_1.RenderOption, { key: "opt_" + option.value, label: option.label, value: option.value, disabled: option.disabled }));
        });
    }, [options]);
    return (React.createElement("div", { className: "nimbus--select-wrapper" },
        memorizedLabel,
        React.createElement("div", { className: "nimbus--select" },
            React.createElement("select", { className: "nimbus--select__field", id: "select_" + name, name: name, value: selectValue, onChange: handleChange },
                memorizedPlaceholder,
                memorizedOptions),
            React.createElement("div", { className: "nimbus--select__append" },
                React.createElement(icons_1.ChevronDownIcon, null)))));
}
exports.default = React.memo(Select);
//# sourceMappingURL=index.js.map